import { render, staticRenderFns } from "./QuestionnairesTab.vue?vue&type=template&id=76b25c41&scoped=true"
import script from "./QuestionnairesTab.vue?vue&type=script&lang=js"
export * from "./QuestionnairesTab.vue?vue&type=script&lang=js"
import style0 from "./QuestionnairesTab.vue?vue&type=style&index=0&id=76b25c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b25c41",
  null
  
)

export default component.exports